(function () {
  const STORAGE_APPLIED = 'suave_founder_applied_emails';
  const STORAGE_CLAIMED = 'suave_founder_claimed_count';

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function getCustomerForm(root) {
    return qs(root, 'form.founder-customer-form');
  }

  function getAppliedEmails() {
    try {
      const raw = localStorage.getItem(STORAGE_APPLIED);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function hasAppliedEmail(email) {
    return getAppliedEmails().indexOf(email) !== -1;
  }

  function addAppliedEmail(email) {
    try {
      const list = getAppliedEmails();
      if (list.indexOf(email) === -1) list.push(email);
      localStorage.setItem(STORAGE_APPLIED, JSON.stringify(list));
    } catch (e) {
      /* ignore */
    }
  }

  function parseClaimed(raw) {
    const n = parseInt(String(raw || '0'), 10);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  }

  function syncClaimedFromStorage(root) {
    const serverClaimed = parseClaimed(root.dataset.claimedCount);
    let storedClaimed = 0;
    try {
      storedClaimed = parseClaimed(localStorage.getItem(STORAGE_CLAIMED));
    } catch (e) {
      storedClaimed = 0;
    }
    root.dataset.claimedCount = String(Math.max(serverClaimed, storedClaimed));
  }

  function persistClaimedCount(claimed) {
    try {
      localStorage.setItem(STORAGE_CLAIMED, String(claimed));
    } catch (e) {
      /* ignore */
    }
  }

  function updateSeatsDisplay(root) {
    const total = parseClaimed(root.dataset.totalSeats);
    let claimed = parseClaimed(root.dataset.claimedCount);
    if (claimed > total) claimed = total;
    const remaining = Math.max(0, total - claimed);

    root.querySelectorAll('[data-founder-claimed]').forEach(function (el) {
      el.textContent = String(claimed);
    });
    root.querySelectorAll('[data-founder-remaining]').forEach(function (el) {
      el.textContent = String(remaining);
    });

    const barEl = qs(root, '[data-founder-progress]');
    if (barEl) {
      barEl.style.width = (total > 0 ? Math.min(100, Math.round((claimed / total) * 100)) : 0) + '%';
    }

    const full = claimed >= total;
    const applyBtn = qs(root, '[data-founder-open]');
    const form = getCustomerForm(root);

    if (applyBtn) {
      applyBtn.disabled = full;
      applyBtn.setAttribute('aria-disabled', full ? 'true' : 'false');
    }
    if (form) form.hidden = full;
    root.querySelectorAll('[data-founder-full]').forEach(function (el) {
      el.hidden = !full;
    });

    return { total, claimed, remaining, full };
  }

  function openModal(root) {
    const modal = qs(root, '[data-founder-modal]');
    if (!modal) return;
    modal.hidden = false;
    document.body.classList.add('founder-modal-open');
    const form = getCustomerForm(root);
    if (form) form.setAttribute('data-shopify-captcha', 'true');
    const first = qs(root, '[data-founder-name]');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }

  function closeModal(root) {
    const modal = qs(root, '[data-founder-modal]');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('founder-modal-open');
  }

  function showFormState(root) {
    qs(root, '[data-founder-form-wrap]')?.removeAttribute('hidden');
    qs(root, '[data-founder-success]')?.setAttribute('hidden', '');
  }

  function showSuccessState(root, discountCode) {
    qs(root, '[data-founder-form-wrap]')?.setAttribute('hidden', '');
    const success = qs(root, '[data-founder-success]');
    if (success) {
      success.removeAttribute('hidden');
      const codeEl = qs(root, '[data-founder-code-display]');
      if (codeEl) codeEl.textContent = discountCode || '';
    }
  }

  function buildContactBody(root, name, email) {
    const code = root.dataset.discountCode || '';
    const pct = root.dataset.discountPercent || '20';
    return (
      "Founder's Feedback Program application\n\n" +
      'Name: ' +
      name +
      '\nEmail: ' +
      email +
      '\n\nPlease send discount code: ' +
      code +
      ' (' +
      pct +
      '% off) to this applicant.'
    );
  }

  function responseLooksSuccessful(html) {
    if (!html) return false;
    const text = String(html).toLowerCase();
    if (
      text.indexOf('form__message--error') !== -1 ||
      text.indexOf('class="errors"') !== -1 ||
      text.indexOf('missing captcha') !== -1
    ) {
      return false;
    }
    if (
      text.indexOf('posted_successfully') !== -1 ||
      text.indexOf('customer_posted') !== -1 ||
      text.indexOf('contact_posted') !== -1 ||
      text.indexOf('newsletter-form__message--success') !== -1 ||
      text.indexOf('form-success') !== -1 ||
      text.indexOf('thank you') !== -1 ||
      text.indexOf('thanks for subscribing') !== -1
    ) {
      return true;
    }
    if (
      (text.indexOf('already') !== -1 && text.indexOf('subscribed') !== -1) ||
      (text.indexOf('already') !== -1 && text.indexOf('taken') !== -1)
    ) {
      return true;
    }
    return false;
  }

  function urlLooksSuccessful(url) {
    const value = String(url || '').toLowerCase();
    return (
      value.indexOf('customer_posted') !== -1 ||
      value.indexOf('contact_posted') !== -1 ||
      value.indexOf('form_type=customer') !== -1
    );
  }

  function responseHasErrors(html) {
    const text = String(html).toLowerCase();
    return (
      text.indexOf('form__message--error') !== -1 ||
      text.indexOf('class="errors"') !== -1 ||
      text.indexOf('missing captcha') !== -1 ||
      text.indexOf('"errors"') !== -1
    );
  }

  function submitFormViaIframe(form) {
    return new Promise(function (resolve) {
      if (!form) {
        resolve(false);
        return;
      }

      const iframeName = 'founder-iframe-' + Date.now();
      const iframe = document.createElement('iframe');
      iframe.name = iframeName;
      iframe.title = 'Founder program submission';
      iframe.style.cssText =
        'position:fixed;width:1px;height:1px;opacity:0;pointer-events:none;border:0;left:-9999px';

      let settled = false;
      let loadCount = 0;
      let lastHtml = '';

      function finish(ok) {
        if (settled) return;
        settled = true;
        form.removeAttribute('target');
        window.setTimeout(function () {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 300);
        resolve(!!ok);
      }

      iframe.onload = function () {
        loadCount += 1;
        if (loadCount === 1) return;

        try {
          const win = iframe.contentWindow;
          const loc = win && win.location ? win.location.href : '';
          const doc = iframe.contentDocument || (win && win.document);
          lastHtml = doc && doc.documentElement ? doc.documentElement.innerHTML : '';
          const ok =
            urlLooksSuccessful(loc) ||
            responseLooksSuccessful(lastHtml) ||
            (loadCount >= 2 && !responseHasErrors(lastHtml));
          finish(ok);
        } catch (e) {
          finish(true);
        }
      };

      document.body.appendChild(iframe);
      form.target = iframeName;
      form.submit();

      window.setTimeout(function () {
        if (loadCount >= 2 && !responseHasErrors(lastHtml)) {
          finish(true);
        } else {
          finish(false);
        }
      }, 15000);
    });
  }

  function runWithCaptcha(form, callback) {
    if (!form) return Promise.resolve(false);

    form.setAttribute('data-shopify-captcha', 'true');

    if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
      return new Promise(function (resolve) {
        window.Shopify.captcha.protect(form, function () {
          Promise.resolve(callback()).then(resolve);
        });
      });
    }

    return callback();
  }

  function submitCustomerForm(root) {
    const form = getCustomerForm(root);
    return runWithCaptcha(form, function () {
      return submitFormViaIframe(form);
    });
  }

  function submitMerchantContact(root, name, email) {
    const wrap = qs(root, '[data-founder-contact-form]');
    const form = wrap ? wrap.querySelector('form') : null;
    if (!form) return Promise.resolve(false);

    const nameField = form.elements.namedItem('contact[name]');
    const emailField = form.elements.namedItem('contact[email]');
    const bodyField = form.elements.namedItem('contact[body]');
    if (nameField) nameField.value = name;
    if (emailField) emailField.value = email;
    if (bodyField) bodyField.value = buildContactBody(root, name, email);

    return runWithCaptcha(form, function () {
      return submitFormViaIframe(form);
    });
  }

  function submitWebhook(root, name, email) {
    const url = (root.dataset.webhookUrl || '').trim();
    if (!url) return Promise.resolve(null);

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        name: name,
        email: email,
        discount_code: root.dataset.discountCode || '',
        discount_percent: root.dataset.discountPercent || '20',
        source: 'founder-program',
      }),
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json().catch(function () {
          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function incrementClaimed(root) {
    const total = parseClaimed(root.dataset.totalSeats);
    let claimed = parseClaimed(root.dataset.claimedCount) + 1;
    if (claimed > total) claimed = total;
    root.dataset.claimedCount = String(claimed);
    persistClaimedCount(claimed);
    return updateSeatsDisplay(root);
  }

  function completeSuccess(root, email, webhookResult) {
    if (webhookResult && typeof webhookResult.claimed === 'number') {
      root.dataset.claimedCount = String(webhookResult.claimed);
      persistClaimedCount(webhookResult.claimed);
    } else {
      incrementClaimed(root);
    }
    addAppliedEmail(email);
    showSuccessState(root, root.dataset.discountCode);
    updateSeatsDisplay(root);
  }

  async function handleSubmit(root, e) {
    e.preventDefault();
    syncClaimedFromStorage(root);
    const state = updateSeatsDisplay(root);
    if (state.full) return;

    const form = e.target;
    const nameInput = qs(root, '[data-founder-name]');
    const emailInput = qs(root, '[data-founder-email]');
    const submitBtn = qs(root, '[data-founder-submit]');
    const errEl = qs(root, '[data-founder-error]');

    const name = (nameInput?.value || '').trim();
    const email = (emailInput?.value || '').trim().toLowerCase();

    if (!name || !email) return;
    if (emailInput && !emailInput.checkValidity()) {
      emailInput.reportValidity();
      return;
    }

    if (hasAppliedEmail(email)) {
      showSuccessState(root, root.dataset.discountCode);
      return;
    }

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }
    if (errEl) errEl.hidden = true;

    try {
      const customerOk = await submitCustomerForm(root);

      if (!customerOk) {
        const contactOk = await submitMerchantContact(root, name, email);
        const webhookResult = await submitWebhook(root, name, email);
        if (!contactOk && !webhookResult) {
          throw new Error('submit_failed');
        }
        completeSuccess(root, email, webhookResult);
        return;
      }

      submitMerchantContact(root, name, email);
      const webhookResult = await submitWebhook(root, name, email);
      completeSuccess(root, email, webhookResult);
    } catch (err) {
      if (errEl) {
        errEl.hidden = false;
        errEl.textContent =
          root.dataset.errorMessage ||
          'Something went wrong. Please try again or contact us.';
      }
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-busy');
      }
    }
  }

  function initSection(root) {
    if (!root || root.dataset.founderInit === '1') return;
    root.dataset.founderInit = '1';

    syncClaimedFromStorage(root);
    updateSeatsDisplay(root);

    const form = getCustomerForm(root);
    if (form) form.setAttribute('data-shopify-captcha', 'true');

    const openBtn = qs(root, '[data-founder-open]');
    if (openBtn) {
      openBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showFormState(root);
        openModal(root);
      });
    }

    root.querySelectorAll('[data-founder-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closeModal(root);
      });
    });

    const backdrop = qs(root, '[data-founder-backdrop]');
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closeModal(root);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const modal = qs(root, '[data-founder-modal]');
      if (modal && !modal.hidden) closeModal(root);
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        handleSubmit(root, e);
      });
    }

    const copyBtn = qs(root, '[data-founder-copy-code]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        const code = root.dataset.discountCode || '';
        if (!code || !navigator.clipboard) return;
        const original = copyBtn.textContent;
        navigator.clipboard.writeText(code).then(function () {
          copyBtn.textContent = root.dataset.copiedLabel || 'Copied!';
          setTimeout(function () {
            copyBtn.textContent = original;
          }, 2000);
        }).catch(function () {
          /* ignore */
        });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-founder-program]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const el = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!el) return;
    const root = el.querySelector('[data-founder-program]');
    if (root) initSection(root);
  });
})();
